var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.371,
    height: 43.371,
    viewBox: "0 0 43.371 43.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "0070bb6714a3e1029a7333bdf7179d78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.835 0h-34.3A4.542 4.542 0 0 0 0 4.536V38.83a4.543 4.543 0 0 0 4.536 4.541H38.83a4.543 4.543 0 0 0 4.541-4.536v-34.3A4.542 4.542 0 0 0 38.835 0zm1.7 38.835a1.7 1.7 0 0 1-1.7 1.7H4.536a1.7 1.7 0 0 1-1.7-1.7v-34.3a1.7 1.7 0 0 1 1.7-1.7H38.83a1.7 1.7 0 0 1 1.7 1.7z",
    "data-name": "Path 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.715 32.139H7.657a1.421 1.421 0 0 0 0 2.841h28.058a1.421 1.421 0 1 0 0-2.841z",
    "data-name": "Path 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.078 9.453a.848.848 0 0 0-.066-.217 1.063 1.063 0 0 0-.128-.212c-.089-.142-.133-.195-.146-.195l-.062-.066a.846.846 0 0 0-.195-.133 1.739 1.739 0 0 0-.257-.142 1.066 1.066 0 0 0-.266-.062.983.983 0 0 0-.243-.035h-8.422a1.421 1.421 0 0 0 0 2.841h5.236l-9.533 10.591-8.418-7.794-7.979 8.865a1.431 1.431 0 0 0-.363 1.027 1.415 1.415 0 0 0 2.469.872l6.05-6.723 8.418 7.8L34.29 13.518v5.652a1.421 1.421 0 1 0 2.841 0V9.779a1.265 1.265 0 0 0-.053-.326z",
    "data-name": "Path 6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPerformance);
export default __webpack_public_path__ + "static/media/my-performance.46ece0f5c6bc3f0150d739d800ecebb2.svg";
export { ForwardRef as ReactComponent };